import React, { useEffect, useState } from "react";
import useGlobal from "../../store";
import { getProducts } from "../../services/MetadataService";

import { useHistory } from "react-router-dom";
import { AddCircle } from "@mui/icons-material";
import { IconButton } from "@material-ui/core";

import ProductsList from "../../components/ProductsList";

const ProductsResultList = (props) => {
    const [products, setProducts] = useState()
    const [location, setLocation] = useState('Products')
    let [currentState, currentActions] = useGlobal();
    let history = useHistory();

    useEffect(() => {
        getProducts().then(response => {
            //response.sort((a,b) => a.name > b.name ? 1 : -1)
            console.log(response)
            setProducts(response)
        });
    }, []);

    return <div className="layer3">
            <div className="products-list">
                <ProductsList products={products} />
            </div>
        </div>

}

export default ProductsResultList;
